// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__23bIF","imageUploader":"EGiftCard_imageUploader__15La_"};